import api from './api';
import { withAuditLog } from './auditLogService';

const BASE_URL = '/api/v1/admin/referral-reports';

const cleanParams = (params) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== '' && value !== null && value !== undefined)
);

export const referralReportService = {
  getSummary: (params) => api.get(`${BASE_URL}/summary`, { params: cleanParams(params) }),
  getDetailed: (params) => api.get(`${BASE_URL}/detailed`, { params: cleanParams(params) }),
  getOptions: () => api.get(`${BASE_URL}/options`),
  suspendCode: withAuditLog(
    'REFERRAL_CODE_SUSPEND',
    (referralCodeId, suspendReason) => api.patch(
      `/api/v1/admin/referral-codes/${referralCodeId}/suspend`,
      { suspend_reason: suspendReason }
    ),
    (referralCodeId, suspendReason) => ({
      targetId: referralCodeId,
      targetType: 'referral_code',
      details: { reason: suspendReason },
    })
  ),
  export: (params) => api.get(`${BASE_URL}/export`, {
    params: cleanParams(params),
    responseType: 'blob',
  }),
};
